import DetailsAndNotes from "./DetailsAndNotes";
export default DetailsAndNotes;
